import Image from 'next/image';
import { useTheme } from '../theme/ThemeContext';

export default function Logo(props: {color?: string}) {
  const { isDarkMode } = useTheme();
  const colorImages = {
    light: "/images/icon-dark.png",
    dark: "/images/icon-dark.png",
    white: "/images/icon-white.png",
  };
  
  const getLogoSrc = () => {
    if (props.color && colorImages[props.color as keyof typeof colorImages]) {
      return colorImages[props.color as keyof typeof colorImages];
    }
    return isDarkMode ? colorImages.dark : colorImages.light;
  };
  
  return (
    <Image
      src={getLogoSrc()}
      alt="RightPulse Logo"
      width={32}
      height={32}
      style={{ width: "auto", height: "auto" }}
    />
  );
}